import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import { Badge } from "react-bootstrap";

const CardItem = ({ item, index }) => {
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item?.fullname}</td>
			<td className="text-wrap-mode">{item?.phone}</td>
			<td className="text-wrap-mode">
				{lang === "en" ? item?.package?.name_en : item?.package?.name_ar}
			</td>
			<td className="text-wrap-mode">{item?.subscription_type}</td>
			<td className="text-wrap-mode">
				{!!item?.subscriptionDate ? item?.subscriptionDate?.split("T")[0] : "-"}
			</td>
			<td className="text-wrap-mode">
				{item?.subscriptionExpirationDate?.split("T")[0]}
			</td>
			<td>
				<Badge
					className="text-capitalize"
					variant={`${
						item?.status === "active" ? "success" : "secondary"
					} light`}>
					{Translate[lang][item?.status === "active" ? "active" : "expired"]}
				</Badge>
			</td>
		</tr>
	);
};
export default CardItem;
